import * as _throttle from 'lodash/throttle';

export default {
  data() {
    return {
      tableData: [],
      filteredTableData: [],
      filterKeyword: '',
      throttledFilterTableKeys: null
    };
  },

  watch: {
    /**
     * 当筛选框关键字变化时进行筛选
     */
    filterKeyword(val) {
      this.throttledFilterTableKeys(val);
    }
  },

  created() {
    // 创建筛选框的节流函数
    this.throttledFilterTableKeys = _throttle(keyword => {
      this.filteredTableData = this.tableData.filter(
        item => item[this.fieldForFilter].indexOf(keyword) !== -1
      );
    }, 100);
  }
};
